import { Component, Host, Element, Prop, Event, EventEmitter, Listen, h } from '@stencil/core';
import { KEY_CODES } from '../../utils/variables';
import { generateId } from '../../utils/functions';

@Component({
  tag: 'som-tab',
})
export class SomTab {
  @Element() el: HTMLElement;

  /**
   * This property sets the name of the tab.
   */
  @Prop({reflect: true}) name: string;
  /**
   * This boolean controls if the tab is active.
   */
  @Prop({reflect: true, mutable: true}) active: boolean;

  /**
  *
  */
  @Prop({reflect: true, mutable: true}) dark: boolean = false;

  /**
   * This property can be used to specifically set an ID to the tab. If an ID is not provided, it will be dynamically generated.
   */
  @Prop({reflect: true}) tabId: string = generateId('som-tab');  

  @Event() tabClick: EventEmitter;

  @Listen('keydown')
  async handleKeyDown(e) {
    switch (e.keyCode) {
      case KEY_CODES.ENTER:
      case KEY_CODES.SPACE:
        this.el.click();
        break;
    }  
  }

  @Listen('click', { capture: true })
  handleClick(ev) {
    ev.preventDefault();
    const detail = {
      tabId: this.tabId,
    }

    this.active = true;
    this.tabClick.emit(detail);
  }


  render() {
    return (
      <Host 
        role="tab"
        class={`tab ${this.dark ? 'dark' : ''} ${this.active ? 'active' : ''}`}
        tabindex={this.active ? '0' : '-1'}
        id={this.tabId}
        aria-selected={this.active ? 'true' : 'false'}
      
      >
          {this.name}
      </Host>
    );
  }
}